import { api } from "aldoo-ra/API"

const localizationAPI = api("localization")

// Apply an inline edit to the current language. Pass either:
//   { key, bundleKey?, language, value }   — localized text / bundle key
//   { contentId, field, value, language }  — raw (non-localized) CMS field
export const liveEditSave = (payload) =>
  localizationAPI({ live_edit: payload })
